import React, { useMemo, createContext } from 'react'
import { BillingSubscription } from '@pollination-solutions/pollination-sdk'

export const getActiveBillingPeriods = (
  existingSubscriptions: BillingSubscription[]): {
  'monthly': boolean,
  'yearly': boolean
} => {
  const hasMonthlySubscription = existingSubscriptions.some(sub => 
    sub.status === 'active' &&
    sub.billing_cycle?.interval === 'month'
  )
  const hasYearlySubscription = existingSubscriptions.some(sub => 
    sub.status === 'active' &&
    sub.billing_cycle?.interval === 'year'
  )

  return {
    'monthly': hasMonthlySubscription,
    'yearly': hasYearlySubscription
  }
}

type SubscriptionStatusProviderProps = {
  children: React.ReactNode
  existingSubscriptions: BillingSubscription[]
}

type SubscriptionStatusType = {
  status: ReturnType<typeof getActiveBillingPeriods>
}

export const SubscriptionStatus = createContext({} as SubscriptionStatusType)
export const useSubscriptionStatus = () => {
  const context = React.useContext(SubscriptionStatus)
  if (!context)
    throw new Error('useSubscriptionStatus must be used within a SubscriptionStatusProvider')

  return context
}

export const SubscriptionStatusProvider = ({ 
  children, 
  existingSubscriptions
}: SubscriptionStatusProviderProps) => {
  
  const status = useMemo(() => {
    return getActiveBillingPeriods(existingSubscriptions)
  }, [existingSubscriptions])

  return (
    <SubscriptionStatus.Provider
      value={{
        status: status
      }}
    >
      {children}
    </SubscriptionStatus.Provider>
  )
}
